import { GetBy } from '../_app/cuchillo/core/Element';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class NewDetail extends Default {
  constructor() {
    super();
  }

  beforeShow() {
    super.beforeShow();

    const lazyload = GetBy.class('lazyload');
    for (let i = 0; i < lazyload.length; i++) {
      const image = lazyload[i];
      image.setAttribute('src', image.dataset.src);
    }
  }
}

ControllerPage._addPage('new-detail', NewDetail);
